var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  "dismiss": "Odbaci"
};
export { $553439c3ffb3e492$exports as default };